



















import { defineComponent, reactive, ref, onMounted } from '@vue/composition-api'

export default defineComponent({
  setup() {
    function open_clients() {
      window.open("https://clients-ai.com")
    }
    return {
      open_clients,
    }
  },
})

